import Database from "../Repository/Database";

let database: Database | null = null;
let electron = window.require("electron");
let electronDatabase: any = electron
    && electron.remote
    && electron.remote.getGlobal('ElectronDatabase');

export default function getDatabase(): Database {
    if (null === database) {
        database = new Database(electronDatabase);
    }

    return database;
}